import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
import './style.css'
import { FormErrors } from './formErrors';
import { emailAndPasswordWithPopUpAction } from '../../action/authAction'
import { browserHistory } from 'react-router';
import label from 'material-ui/svg-icons/action/label';

class LinkedWithPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {

            email: '',
            password: '',
            formErrors: { email: '', password: '' },
            emailValid: false,
            passwordValid: false,
            formValid: false,

        }

    }
    componentDidMount() {
        console.log(this.props.info)
        if (this.props.info.email !== null) {
            this.setState({
                emailValid: this.props.info.email,
                email: this.props.info.email
            })
        }
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {
            case 'email':
                emailValid = value.match(this.props.info.email);
                fieldValidationErrors.This = emailValid ? '' : ' email is not registered';
                break;
            case 'password':
                passwordValid = value.length >= 6;
                fieldValidationErrors.Password = passwordValid ? '' : ' is too short';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            emailValid: emailValid,
            passwordValid: passwordValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
    }
    logIn() {

        var email = this.state.email;
        var password = this.state.password;

        let authObj = {
            email,
            password
        }
        // console.log("authObj", authObj)
        this.props.emailAndPasswordWithPopUpAction(authObj, this.props.info)
    }
    SignUp() {
        browserHistory.push("/sign-up")
    }
    render() {
        // console.log(this.props.info, "nova data")
        const {
            Loader,
            error,
            info
        } = this.props;
        return (
            <div>
                <mat.Card zDepth={0} className='col-md-6 col-md-offset-3 col-xs-10 col-xs-offset-1 login'>
                    {
                        (this.props.info.email === null)
                            ?
                            <mat.Card zDepth={1} className='text-justify' style={{ borderRadius: 4, padding: '3%', backgroundColor: '#d2c179' }}>
                                <h4>You have successfully signed into <span style={{ color: 'blue' }}>{info.providerId}</span>, but your <span style={{ color: 'blue' }}>{info.providerId}</span> account does not have a linked MAGE account. To link your accounts, sign in now using your MAGE password.</h4>
                                <br />
                                <span style={{ color: 'red' }}>This facebook account doesnot have an email, please create a facebook account with email </span>
                            </mat.Card>
                            :
                            <mat.Card zDepth={1} className='text-justify' style={{ borderRadius: 4, padding: '3%', backgroundColor: '#d2c179' }}>
                                <h4>You have successfully signed into <span style={{ color: 'blue' }}>{info.providerId}</span>, but your <span style={{ color: 'blue' }}>{info.providerId}</span> account does not have a linked MAGE account. To link your accounts, sign in now using your MAGE password.</h4>
                            </mat.Card>
                    }
                    <br />
                    <div >
                        <p style={{ fontSize: 18 }}>First time here? <a onClick={this.SignUp.bind(this)}>Create an Account</a></p>
                    </div>
                    <div className=''>
                        <h3 style={{ textShadow: '0px 2px 3px gray', fontSize: '2.3em', fontWeight: 'bold', color: '#41c4dd' }}>SIGN IN</h3>
                    </div>
                    <br />
                    <div className="input-group input-group-lg">
                        <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                        {
                            (this.props.info.email === null) ?

                                <input
                                    name="email"
                                    className="form-control"
                                    placeholder="Email"
                                    aria-label="Email"
                                    aria-describedby="sizing-addon1"
                                    value={this.state.email}
                                    onChange={this.handleUserInput}
                                    required
                                />

                                :
                                <div
                                    name="email"
                                    className="form-control"
                                    // placeholder="Email"
                                    // aria-label="Email"
                                    aria-describedby="sizing-addon1"
                                    style={{ backgroundColor: '#bdb9b9' }}
                                    required
                                >  {this.props.info.email}
                                </div>

                        }

                    </div>
                    <br />
                    <div className="input-group input-group-lg">
                        <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                        <input
                            name="password"
                            className="form-control"
                            placeholder="Password"
                            aria-label="Password"
                            type="password"
                            aria-describedby="sizing-addon1"
                            value={this.state.password}
                            onChange={this.handleUserInput}
                            required
                        />
                    </div>
                    <br />
                    <div className='text-center' style={{ fontSize: 16, color: 'red' }}>
                        <FormErrors formErrors={this.state.formErrors} />
                    </div>
                    <div>
                        {(error) ? (
                            <div style={{ fontSize: 16, color: 'red', textAlign: 'center' }}>
                                {error}
                            </div>
                        ) : (
                                <span></span>
                            )}
                    </div>
                    <div>
                        {(Loader === false) ? (
                            <button
                                onClick={this.logIn.bind(this)}
                                className="btn btn-info btn-group-justified"
                                disabled={!this.state.formValid}
                                style={{ fontSize: 20 }}
                            >
                                Sign In
                                </button>
                        ) : (
                                <div className='text-Center'>
                                    <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                </div>
                            )}

                    </div>
                </mat.Card>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        info: state.authReducers.userDetails,
        Loader: state.authReducers.passCode,
        // sucess: state.AdminReducer.ErrorMess,
        error: state.authReducers.PassError,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        emailAndPasswordWithPopUpAction: (action, info) => {
            dispatch(emailAndPasswordWithPopUpAction(action, info))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LinkedWithPopup);


// WEBPACK FOOTER //
// ./src/component/auth/linkedWithPopup.jsx